module.exports = __webpack_public_path__ + "img/reply.ee72562c.svg";